import { createSlice } from "@reduxjs/toolkit";
import { GetRolesResponse } from "../../models/role.model";

interface rolesResponse {
  roles: GetRolesResponse[];
  update: string;
}

const initialState: rolesResponse = {
  roles: [],
  update: "",
};

export const RolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    getRoles: (state: any, action: any) => {
      const { roles } = action.payload;
      state.roles = roles;
    },
    updateServiceRoles: (state: any, action: any) => {
      const { update } = action.payload;
      state.update = update;
    },
  },
});
export const DefaultPassword = createSlice({
  name: "userDefaultPassword",
  initialState: { password: "" },
  reducers: {
    getPassword: (state: any, action: any) => {
      const { password } = action.payload;
      state.password = password;
    },
  },
});

// this is for dispatch
export const { getRoles, updateServiceRoles } = RolesSlice.actions;
export const { getPassword } = DefaultPassword.actions;

// this is for configureStore
const combineReducers = {
  roles: RolesSlice.reducer,
  password: DefaultPassword.reducer,
};

export default combineReducers;
// export default RolesSlice.reducer;
